export default __webpack_public_path__ + "static/media/star.3b46444c.svg";